var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"me-information"},[_c('personal-center',{attrs:{"img-click":_vm.imgClick,"blue":'#c8161d'}}),_c('Loading',{attrs:{"show":_vm.isShowLoading}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }